import React, {Component} from 'react';
import firebase from 'firebase';
import reportarse from '../../img/reportarse.png'

class HomeEspera extends Component{
    constructor(props){
        super(props);
        this.state={

        }
    }

    ReporVia = () =>{
        firebase.database().ref().child('Empleados/'+this.props.userActu.uid).update({
            espera:true
        })
    }

    render(){
        let { userActu, userVehi } = this.props;
        return(
            <div style={{width:'100%', height:'100%'}}>
                <div style={{width:'100%', height:'45%', backgroundColor:'#FBD700', padding:15}}>
                    <p className='titulos'>Bienvenido</p>
                    <p className='titulos'>{userActu.nombre}</p>
                    <p className='subtitulos' >Conductor</p>
                </div>
                <div style={{width:'100%', height:'45%', backgroundColor:'white'}}>
                    <div className='topFix'>
                        <p className='titulosB'>Vehículo asignado</p>
                        <p className='titulos'>{userVehi.movil}</p>
                        <img onClick={this.ReporVia} style={{marginTop:15}} className='imgC' src={reportarse} alt="menu" />
                    </div>
                </div>
                <div className='fixScreen'>
                    <img className='imgC' src={userActu.foto} alt="menu" />
                </div>
            </div>
        )
    }
}
export default HomeEspera;


// WEBPACK FOOTER //
// ./src/Components/perfilEmpleado/homeEspera.js